import React, { useCallback, useEffect, useState } from 'react';

import { IoArrowBack } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';

import {
  ButtonDefault,
  HeaderNavigationPrivate,
  HeaderWizardNewProvider,
  MenuSideBarPrivate,
  SubtitleSecondary,
} from '@components/index';

import StepAddress from './StepAddress';
import StepFinished from './StepFinished';
import StepPrice from './StepPrice';
import StepProvider from './StepProvider';
import StepService from './StepService';

import {
  Container,
  ContainerGroup,
  Content,
  Options,
  OptionsGroup,
  Sections,
} from './styles';

const ProviderNew: React.FC = () => {
  const { goBack } = useHistory();

  const [step, setStep] = useState<number>(1);
  const [stepHistory, setStepHistory] = useState<number>(1);

  const changeStep = (desiredStep: number) => {
    setStep(desiredStep);
  };

  const handleChangeSteps = useCallback(
    (desiredStep: number, willChangeHistory?: boolean) => {
      setStep(desiredStep);
      if (stepHistory < desiredStep || willChangeHistory)
        setStepHistory(desiredStep);
    },
    [stepHistory],
  );

  // useEffect(() => {
  //   if (step === 1 && stepHistory === 1)
  //     newContractStorageService.cleanMany('all');
  // }, [step, stepHistory]);

  const handleGoBack = () => {
    goBack();
  };

  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">
            Adicionar prestador
          </SubtitleSecondary>
          <Options>
            <OptionsGroup>
              <ButtonDefault iconLeft={IoArrowBack} onClick={handleGoBack} />
            </OptionsGroup>
          </Options>
          <HeaderWizardNewProvider
            stepActive={step}
            stepHistory={stepHistory}
            changeStep={changeStep}
          />
          <Sections>
            {step === 1 && (
              <StepProvider
                myStep={1}
                currentStep={step}
                changeStep={handleChangeSteps}
              />
            )}
            {step === 2 && (
              <StepAddress
                myStep={1}
                currentStep={step}
                changeStep={handleChangeSteps}
              />
            )}
            {step === 3 && (
              <StepService
                myStep={3}
                currentStep={step}
                changeStep={handleChangeSteps}
              />
            )}
            {step === 4 && (
              <StepPrice
                myStep={4}
                currentStep={step}
                changeStep={handleChangeSteps}
              />
            )}
            {step === 5 && (
              <StepFinished
                myStep={5}
                currentStep={step}
                changeStep={handleChangeSteps}
              />
            )}
          </Sections>
        </Content>
      </ContainerGroup>
    </Container>
  );
};

export default ProviderNew;
